import { render } from "./HelpDialog.vue?vue&type=template&id=92bf4ac8&scoped=true"
import script from "./HelpDialog.vue?vue&type=script&lang=js"
export * from "./HelpDialog.vue?vue&type=script&lang=js"

import "./HelpDialog.vue?vue&type=style&index=0&id=92bf4ac8&scoped=true&lang=css"

import exportComponent from "/builds/platform/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92bf4ac8"]])

export default __exports__